(function () {
  // Read tier once — set synchronously in <head> by device-capability-detection.liquid
  // and never changes during the page lifetime.
  // Dependency note: device-capability-detection.liquid MUST stay inline and MUST
  // run before this deferred script executes. Inline scripts always finish before
  // any deferred script begins (per spec), so this read is safe as long as that
  // snippet is never itself converted to a deferred/external script.
  const _tier = document.documentElement.getAttribute('data-device-tier');

  // Minimal/low tier: remove the initial class immediately and exit.
  // The body starts with page-transitioning set server-side, so without this
  // the 9+ CSS animations still run during initial page load on old phones.
  if (_tier === 'minimal' || _tier === 'low') {
    document.body.classList.remove('page-transitioning');
    return;
  }

  let navigationTimeout;
  let hideTimeout;
  // Bug 3: prevents window.load from dismissing the overlay mid-navigation.
  let navigationInFlight = false;

  // Hide overlay after page fully loads and images render
  function hideOverlay() {
    clearTimeout(hideTimeout);
    clearTimeout(navigationTimeout);

    // Bug 3: don't dismiss overlay while a user-initiated navigation is in progress.
    // window.load can fire after a click on slow connections (large assets still
    // loading when the user clicks), which would prematurely remove page-transitioning.
    if (navigationInFlight) return;

    const headerLogos = document.querySelectorAll('.header__logo img');
    let loadedCount = 0;
    const totalLogos = headerLogos.length;

    if (totalLogos === 0) {
      hideTimeout = setTimeout(function () {
        document.body.classList.remove('page-transitioning');
      }, 200);
      return;
    }

    function checkAllLoaded() {
      loadedCount++;
      if (loadedCount >= totalLogos) {
        document.body.classList.remove('page-transitioning');
      }
    }

    headerLogos.forEach(function (img) {
      if (img.complete && img.naturalHeight !== 0) {
        checkAllLoaded();
      } else {
        // Bug 1: { once: true } ensures listeners auto-remove after firing, preventing
        // accumulation when hideOverlay() is called multiple times (DOMContentLoaded
        // then load both trigger it).
        img.addEventListener('load', checkAllLoaded, { once: true });
        img.addEventListener('error', checkAllLoaded, { once: true });
      }
    });

    // Bug 2: assign to hideTimeout so pagehide can cancel this timer, and so
    // a rapid second hideOverlay() call doesn't spawn a second untracked timer.
    hideTimeout = setTimeout(function () {
      document.body.classList.remove('page-transitioning');
    }, 400);
  }

  // Add page-transitioning class on navigation
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a');
    if (link && link.href && !link.target && !link.hasAttribute('download')) {
      // Skip links that open drawers/modals (search, cart, etc.) - they don't navigate
      if (link.hasAttribute('aria-controls')) return;

      const url = new URL(link.href);
      if (url.hostname === window.location.hostname) {
        // _tier is cached at IIFE init — skip overlay on low-end devices.
        // The 6 continuous animations (quillFloat with 85 keyframes, glowPulse,
        // textureDrift, etc.) consume all render budget on < 4 GB RAM devices,
        // blocking touch events and making the page appear frozen.
        if (_tier === 'minimal' || _tier === 'low') return;

        navigationInFlight = true; // Bug 3: guard hideOverlay against load event
        document.body.classList.add('page-transitioning');

        // Safety timeout - remove class after 2.5s if navigation fails or stalls.
        // Reduced from 5000ms: on mid-range Android the overlay was perceived as
        // "slowing the site down" because 5s is a long time to show a full-screen
        // overlay when navigation silently fails (Janet's report, 2026-05-01).
        clearTimeout(navigationTimeout);
        navigationTimeout = setTimeout(function () {
          navigationInFlight = false; // Bug 3: timed out, allow hideOverlay again
          document.body.classList.remove('page-transitioning');
        }, 2500);
      }
    }
  });

  // Remove class as soon as DOM is ready (don't wait for slow assets)
  document.addEventListener('DOMContentLoaded', hideOverlay);

  // Redundant safety on full load in case DOM event fired before logos available
  window.addEventListener('load', hideOverlay);

  // Also handle pageshow (for back/forward navigation)
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      hideOverlay();
    }
  });

  // Remove class if page is navigating away; clear all pending timers
  window.addEventListener('pagehide', function () {
    navigationInFlight = false;
    clearTimeout(navigationTimeout);
    clearTimeout(hideTimeout);
  });
})();
